<template>
  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col :xs="24" :sm="24" :md="10" :lg="10" class="history-video-heading">
          <Divider orientation="left">{{ langMap.historyVideo[lang] }}</Divider>
          <div class="video-record-control">
            <span class="video-record-label">{{ langMap.videoRecord[lang] }}</span>
            <i-switch v-model="videoRecordEnabled" :loading="videoRecordLoading" @on-change="handleVideoRecordChange">
              <span slot="open">{{ langMap.enabled[lang] }}</span>
              <span slot="close">{{ langMap.disabled[lang] }}</span>
            </i-switch>
          </div>
          </Col>
          <Col :xs="24" :sm="24" :md="14" :lg="14">
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <FormItem :label="langMap.robot[lang]" class="leftFlex">
                <Select v-model="searchForm.robotId" clearable>
                  <Option :key="item.id" :value="item.id" v-for="item in robotList">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem :label="langMap.videoTime[lang]" class="leftFlex">
                <Date-picker v-model="searchForm.times" type="datetimerange" :placeholder="langMap.selectDateAndTime[lang]"
                  format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
              </FormItem>
              <Button type="info" style="margin-left:20px;" @click="searchData">{{ langMap.search[lang] }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table :height="height" :loading="tableLoading" border :columns="col" :data="videoList"></Table>
      <!--分页数据-->
      <div style="text-align:center;padding-top:10px;" v-if="videoList.length > 0">
        <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
      </div>
    </Card>

    <Modal :class="['modal-video', {fullscreenMode: isFullscreen}]" :mask-closable="false" v-model="videoShow" @on-visible-change="cancel" :title="langMap.videoPlay[lang]"
      :width="isFullscreen ? '100%' : '830px'" :style="isFullscreen ? {position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, margin: 0, zIndex: 9999} : {}">
      <div :style="isFullscreen ? {width: '100vw', height: '100vh', margin: '-24px'} : {}">
        <Row :style="isFullscreen ? {height: '100%'} : {}">
          <Col span="24" :style="isFullscreen ? {height: '100%'} : {}">
          <div ref="videoContainer" class="videoContainer" :style="{
            position: 'relative',
            width: isFullscreen ? 'calc(100vw - 1px)' : '100%',
            height: isFullscreen ? '100%' : 'auto',
            background: '#000',
            display: 'flex',
            flexDirection: 'column',
            left: isFullscreen ? '8px' : 'auto',
            top: isFullscreen ? '8px' : 'auto'
          }">
            <video id="videoLeftElement" ref="videoLeft" autoplay muted :style="{
              display: 'block',
              width: '100%',
              height: isFullscreen ? '100%' : '600px',
              flex: isFullscreen ? 1 : 'auto',
              objectFit: 'contain'
            }" controlsList="nodownload">
            </video>
            <!-- 自定义播放控制条 -->
            <div class="custom-controls" :style="{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              width: '100%',
              zIndex: 9999
            }" @mouseenter="showControls = true" @mouseleave="showControls = false">
              <!-- 进度条 -->
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
                <span>{{ formatTime(displayCurrentTime) }}</span>
                <input type="range" ref="progressBar" min="0" :max="displayVideoDuration" :value="displayCurrentTime" 
                  @input="onProgressBarChange" style="flex: 1; cursor: pointer;" />
                <span>{{ (videoDuration > 0 && isFinite(displayVideoDuration)) ? formatTime(displayVideoDuration) : '' }}</span>
              </div>
              <!-- 控制按针 -->
              <div style="display: flex; gap: 15px; align-items: center;">
                <Tooltip :content="isPlaying ? langMap.pause[lang] : langMap.play[lang]" placement="top">
                  <Icon :type="isPlaying ? 'md-pause' : 'md-play'" @click="togglePlay" style="font-size: 20px; color: #fff; cursor: pointer;"></Icon>
                </Tooltip>
                <div style="position: relative; display: flex; align-items: center; gap: 8px;" @mouseenter="showVolumeSlider = true" @mouseleave="showVolumeSlider = false">
                  <Tooltip :content="isMuted ? langMap.videoUnmute[lang] : langMap.videoMute[lang]" placement="top">
                    <Icon :type="isMuted ? 'md-volume-off' : (volume > 0.5 ? 'md-volume-up' : 'md-volume-down')" @click="toggleMute" style="font-size: 20px; color: #fff; cursor: pointer;"></Icon>
                  </Tooltip>
                  <!-- 音量滑块 -->
                  <div v-show="showVolumeSlider" style="display: flex; align-items: center;">
                    <input type="range" min="0" max="100" :value="volume * 100" @input="onVolumeChange" 
                      style="width: 80px; height: 4px; cursor: pointer;" />
                  </div>
                </div>
                <Tooltip :content="isFullscreen ? langMap.videoExitFullscreen[lang] : langMap.videoFullscreen[lang]" placement="top" style="margin-left: auto;">
                  <Icon :type="isFullscreen ? 'md-contract' : 'md-expand'" @click="toggleFullscreen" style="font-size: 20px; color: #fff; cursor: pointer;"></Icon>
                </Tooltip>
              </div>
            </div>
          </div>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button type="text" @click="videoShow = false">{{ langMap.close[lang] }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import * as timeUtil from '@/utils/dateTimeUtil.js';
import flvjs from 'flv.js';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { getSocketUrl } from '@/utils/websocket'

export default {
  components: {
  },
  data() {
    return {
      langMap:langMap,
      height: (document.documentElement.clientHeight - 300),
      robotList: [],
      videoList: [],
      videoPlayUrlHistoryPrefix: getSocketUrl() +'/video/',
      videoShow: false,
      leftFlvPlayer: null,

      btnLoading: false,
      videoRecordEnabled: true,
      videoRecordLoading: false,
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      searchForm: {
        robotId: '',
        times: [],
      },
      firstTimestamp: 0,
      videoDuration: 0,
      currentTime: 0,
      isPlaying: false,
      isMuted: true,
      showControls: true,
      isFullscreen: false,
      escHandler: null,
      videoEnded: false,
      volume: 1.0,
      showVolumeSlider: false,
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    displayCurrentTime() {
      return Math.max(0, this.currentTime - this.firstTimestamp);
    },
    displayVideoDuration() {
      return Math.max(0, this.videoDuration - this.firstTimestamp);
    },
    col() {
      return [
        {
          title: '#',
          width: 80,
          key: 'index',
          render(h, params) {
            return h("span", params.index + 1)
          }
        },
        {
          title: langMap.robot[this.lang],
          width: 180,
          key: 'name'
        },
        {
          title: langMap.fileName[this.lang],
          key: 'fileName'
        },
        {
          title: langMap.startTime[this.lang],
          idth: 210,
          key: 'beginTime',
        },
        {
          title: langMap.fileDuration[this.lang],
          idth: 210,
          key: 'duration',
        },
        {
          title: langMap.archiveStatus[this.lang],
          width: 110,
          key: 'isArchived',
          align: 'center',
          render: (h, params) => {
            const archived = Number(params.row.isArchived) === 1
            return h(
              'Tag',
              { props: { color: archived ? 'gold' : 'default' } },
              archived ? langMap.archived[this.lang] : langMap.notArchived[this.lang]
            )
          }
        },
        {
          title: langMap.operation[this.lang],
          width: this.lang === 'zh' ? 220 : 280,
          align: 'center',
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h('Button', {
                props: {
                  size: 'small'
                },
                class: 'sci-fi-btn video-play-btn',
                on: {
                  click: () => {
                    this.switchVideo(params.row)
                  }
                }
              }, langMap.play[this.lang])
            )
            renderArray.push(
              h('Button', {
                props: {
                  size: 'small'
                },
                class: 'sci-fi-btn video-download-btn',
                on: {
                  click: () => {
                    this.downloadVideo(params.row);
                  }
                }
              }, langMap.download[this.lang])
            );
            // 归档与播放/下载无关，任何记录都可切换
            if (params.row.id) {
              const archived = Number(params.row.isArchived) === 1
              renderArray.push(
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  class: archived
                    ? 'sci-fi-btn archive-btn is-archived'
                    : 'sci-fi-btn archive-btn',
                  on: {
                    click: () => {
                      this.toggleArchive(params.row)
                    }
                  }
                }, archived ? langMap.unarchive[this.lang] : langMap.archive[this.lang])
              )
            }
            return h('div', { class: 'video-op-cell' }, renderArray)
          }
        }
      ]
    },
  },
  methods: {
    hideText(h, text, width) {
      return h('div', [
        // 显示的位置上方
        h('Tooltip', {
          props: { placement: 'top', transfer: true }
        }, [
          h('span', {
            style: {
              display: 'inline-block',
              width: width,
              overflow: 'hidden',
              // 同样在这里隐藏溢出内容
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }, text),
          // 显示的内容
          h('span', {
            slot: 'content',
            style: { whiteSpace: 'normal', wordBreak: 'break-all' }
          }, text)
        ])
      ])
    },
    //获取列表
    getList() {
      this.tableLoading = true;
      this.searchForm.robotId = this.searchForm.robotId ? this.searchForm.robotId : '';
      let stat = '';
      let end = '';
      if (this.searchForm.times.length == 2) {
        if (this.searchForm.times[0]) {
          stat = timeUtil.formatTime(this.searchForm.times[0]);
        }
        if (this.searchForm.times[1]) {
          end = timeUtil.formatTime(this.searchForm.times[1]);
        }
      }
      api.getData('video-server/video/list?index=' + this.index + "&robotId=" + this.searchForm.robotId
        + "&start=" + stat + "&end=" + end,
        this).then((res) => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg,
            });
          } else {
            this.videoList = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    getVideoRecordStatus () {
      return api.getData('video-server/videoRecord/get', this).then(res => {
        if (res.state === 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          })
          return false
        }
        if (res.data && typeof res.data.enabled === 'boolean') {
          this.videoRecordEnabled = res.data.enabled
        } else {
          this.videoRecordEnabled = true
        }
        return true
      })
    },
    handleVideoRecordChange (enabled) {
      if (this.videoRecordLoading) {
        return
      }
      this.videoRecordLoading = true
      api.postData('video-server/videoRecord/switch?enabled=' + encodeURIComponent(enabled), {}, this).then(res => {
        if (res.state === 0) {
          this.videoRecordEnabled = !enabled
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          })
          return false
        }
        this.$Notice.success({
          title: langMap.success[this.lang],
          desc: res.message
        })
        return this.getVideoRecordStatus()
      }, () => {
        this.videoRecordEnabled = !enabled
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.configNotFound[this.lang]
        })
        return false
      }).then(() => {
        this.videoRecordLoading = false
      }, () => {
        this.videoRecordLoading = false
      })
    },
    getRobot() {
      api.getData("robot-server/robot/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.robotList = res.data
        }
      });
    },
    switchVideo(row) {
      if (!this.videoPlayUrlHistoryPrefix) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.historyVideoUrlNotConfigured[this.lang],
        });
        return;
      }
      this.videoShow = true;
      this.createFlvPlayer(row.relativePath);
    },
    downloadVideo(row) {
      window.location.href = encodeURI(this.videoPlayUrlHistoryPrefix + row.relativePath);
    },
    // 归档/取消归档历史视频，归档后自动清理会跳过该视频文件
    toggleArchive (row) {
      if (!row || !row.id) {
        return
      }
      const archived = Number(row.isArchived) === 1
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: archived
          ? langMap.confirmUnarchiveVideo[this.lang]
          : langMap.confirmArchiveVideo[this.lang],
        onOk: () => {
          this.$Spin.show()
          const url =
            (archived
              ? 'video-server/video/unarchive/'
              : 'video-server/video/archive/') + row.id
          api.postData(url, {}, this).then(res => {
            if (res.state == 0) {
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: res.msg
              })
            } else {
              this.$Notice.success({
                title: langMap.success[this.lang],
                desc: res.message
              })
              this.getList()
            }
            this.$Spin.hide()
          })
        }
      })
    },
    cancel(status) {
      if (!status) {
        this.isFullscreen = false;
        this.pausemix();
      }
    },
    //新建flv实例
    createFlvPlayer(url) {
      var _this = this;
      this.firstTimestamp = 0;
      this.videoDuration = 0;
      this.currentTime = 0;
      this.isPlaying = true;
      this.isMuted = true;
      
      if (flvjs.isSupported()) {
        var leftVideoElement = this.$refs.videoLeft;
        leftVideoElement.muted = true;
        leftVideoElement.volume = this.volume;
        var leftFlvPlayer = flvjs.createPlayer({
          type: 'flv',
          isLive: false,
          url: this.videoPlayUrlHistoryPrefix + url,
        });
        leftFlvPlayer.attachMediaElement(leftVideoElement);
        leftFlvPlayer.load();
        leftFlvPlayer.play();
        this.leftFlvPlayer = leftFlvPlayer;
        
        // 监听视频時间更新
        leftVideoElement.addEventListener('timeupdate', function() {
          _this.currentTime = leftVideoElement.currentTime;
          // 第一次记录偏移量
          if (_this.firstTimestamp === 0 && leftVideoElement.currentTime > 0) {
            _this.firstTimestamp = leftVideoElement.currentTime;
            console.log('记录偏移量:', _this.firstTimestamp);
          }
        });
        
        // 监听视频元数据加载
        leftVideoElement.addEventListener('loadedmetadata', function() {
          _this.videoDuration = leftVideoElement.duration || 0;
          console.log('视频时長:', _this.videoDuration);
        });
        
        // 也监听 durationchange
        leftVideoElement.addEventListener('durationchange', function() {
          _this.videoDuration = leftVideoElement.duration || 0;
          console.log('视频时長 (durationchange):', _this.videoDuration);
        });
        
        // 监听播放/暂停
        leftVideoElement.addEventListener('play', () => {
          this.isPlaying = true;
        });
        
        leftVideoElement.addEventListener('pause', () => {
          this.isPlaying = false;
        });
        
        // 监听视频结束事件
        leftVideoElement.addEventListener('ended', () => {
          // 视频播放完了后，仅置位标记
          _this.videoEnded = true;
        });
      }
    },
    
    formatTime(seconds) {
      if (!seconds) return '00:00';
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var secs = Math.floor(seconds % 60);
      var pad = (num) => String(num).padStart(2, '0');
      return hours > 0 ? pad(hours) + ':' + pad(minutes) + ':' + pad(secs) : pad(minutes) + ':' + pad(secs);
    },
    
    onProgressBarChange(event) {
      // 用户拖拽进度条，需要加上偏移量
      var displayValue = parseFloat(event.target.value);
      var actualValue = displayValue + this.firstTimestamp;
      this.$refs.videoLeft.currentTime = actualValue;
    },
    
    togglePlay() {
      var video = this.$refs.videoLeft;
      if (video.paused) {
        // 如果视频已结束且当前時间在最后，才重新开始
        if (this.videoEnded && Math.abs(video.currentTime - this.videoDuration) < 0.1) {
          video.currentTime = this.firstTimestamp || 0;
          this.videoEnded = false;
        }
        video.play();
      } else {
        video.pause();
      }
    },
    
    toggleMute() {
      var video = this.$refs.videoLeft;
      video.muted = !video.muted;
      this.isMuted = video.muted;
    },
    
    onVolumeChange(event) {
      var video = this.$refs.videoLeft;
      var newVolume = parseFloat(event.target.value) / 100;
      this.volume = newVolume;
      video.volume = newVolume;
      
      // 如果音量大于0，自动取消静音
      if (newVolume > 0 && this.isMuted) {
        video.muted = false;
        this.isMuted = false;
      }
      // 如果音量为0，自动静音
      if (newVolume === 0 && !this.isMuted) {
        video.muted = true;
        this.isMuted = true;
      }
    },
    
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },

    //停止混流播放
    pausemix() {
      this.leftFlvPlayer.pause()
      this.leftFlvPlayer.unload()
      this.leftFlvPlayer.detachMediaElement()
      this.leftFlvPlayer.destroy()
      this.leftFlvPlayer = null
    },
  },
  mounted() {
    this.getVideoRecordStatus().then(() => {
      this.getRobot()
      this.getList()
    })
    // 监听 ESC 键
    var self = this;
    this.escHandler = function(event) {
      // 全屏模式下禁用 ESC
      if (event.keyCode === 27 && self.videoShow && self.isFullscreen) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    };
    // 使用捕获阶段监听，优先级最高
    document.addEventListener('keydown', this.escHandler, true);
  },
  beforeDestroy() {
    if (this.escHandler) {
      document.removeEventListener('keydown', this.escHandler, true);
    }
    this.pausemix()
  }
}
</script>

<style scoped lang="less">
video {
  /* 隐藏原生工具栏 */
  &::-webkit-media-controls {
    display: none !important;
  }
  &::-webkit-media-controls-panel {
    display: none !important;
  }
  &::-moz-media-controls {
    display: none !important;
  }
}

.custom-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #222;
  padding: 8px;
  color: #fff;
  font-size: 12px;
  z-index: 9999;
}

/* 全屏时的样式 - video元素全屏 */
video:fullscreen ~ .custom-controls,
video:-webkit-full-screen ~ .custom-controls,
video:-moz-full-screen ~ .custom-controls,
video:-ms-fullscreen ~ .custom-controls {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}

/* 容器全屏样式 */
:fullscreen,
:-webkit-full-screen,
:-moz-full-screen,
:-ms-fullscreen {
  background: #000;
}
</style>

<!-- 表格列由 render 函数生成，不带 scoped 属性，这里用页面根类名限定作用范围 -->
<style lang="less">
.articlemanagement {
  .video-op-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
  }

  /* 操作列 hover 时按钮会上浮并外扩阴影，单元格默认 overflow: hidden 会把它切掉 */
  .ivu-table-tbody td:last-child .ivu-table-cell {
    overflow: visible;
  }

  /* 科幻按钮基础样式，与警情处置页保持一致 */
  .sci-fi-btn {
    position: relative;
    overflow: hidden;
    border: none !important;
    border-radius: 6px !important;
    font-weight: 500;
    letter-spacing: 1px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
    min-width: 29px;
    min-height: 29px;
  }

  .sci-fi-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
    z-index: 1;
  }

  .sci-fi-btn:hover::before {
    left: 100%;
  }

  .sci-fi-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }

  .sci-fi-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }

  /* 播放按钮 - 蓝色 */
  .video-play-btn:not([disabled]) {
    background: linear-gradient(135deg, #2d8cf0, #1e6fd9) !important;
    border-color: #2d8cf0 !important;
    color: #fff !important;
    box-shadow: 0 4px 15px rgba(45, 140, 240, 0.4);
  }

  .video-play-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #1e6fd9, #2d8cf0) !important;
    box-shadow: 0 8px 25px rgba(45, 140, 240, 0.6);
  }

  /* 下载按钮 - 绿色 */
  .video-download-btn:not([disabled]) {
    background: linear-gradient(135deg, #19be6b, #0f9e56) !important;
    border-color: #19be6b !important;
    color: #fff !important;
    box-shadow: 0 4px 15px rgba(25, 190, 107, 0.4);
  }

  .video-download-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #0f9e56, #19be6b) !important;
    box-shadow: 0 8px 25px rgba(25, 190, 107, 0.6);
  }

  /* 归档按钮 - 紫红色，与播放、下载区分 */
  .archive-btn:not([disabled]) {
    background: linear-gradient(135deg, #c026d3, #a21caf) !important;
    border-color: #c026d3 !important;
    color: #fff !important;
    box-shadow: 0 4px 15px rgba(192, 38, 211, 0.4);
  }

  .archive-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #a21caf, #c026d3) !important;
    box-shadow: 0 8px 25px rgba(192, 38, 211, 0.6);
  }

  /* 取消归档按钮 - 深紫红，表示当前处于归档保护中 */
  .archive-btn.is-archived:not([disabled]) {
    background: linear-gradient(135deg, #86198f, #6b1370) !important;
    border-color: #86198f !important;
    box-shadow: 0 4px 15px rgba(134, 25, 143, 0.4);
  }

  .archive-btn.is-archived:not([disabled]):hover {
    background: linear-gradient(135deg, #6b1370, #86198f) !important;
    box-shadow: 0 8px 25px rgba(134, 25, 143, 0.6);
  }
  .history-video-heading {
    display: flex;
    align-items: center;
    min-height: 42px;
  }

  .history-video-heading .ivu-divider {
    flex: 1;
    min-width: 0;
    margin: 12px 0;
  }

  .video-record-control {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    max-width: 100%;
    margin-left: 14px;
    padding: 4px 8px 4px 12px;
    border: 1px solid rgba(76, 224, 211, 0.72);
    border-radius: 18px;
    background: linear-gradient(135deg, rgba(29, 165, 77, 0.88), rgba(22, 129, 47, 0.78));
    box-shadow: 0 0 14px rgba(22, 193, 190, 0.24);
    white-space: nowrap;
  }

  .video-record-label {
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    text-shadow: 0 0 6px rgba(45, 212, 191, 0.55);
    white-space: nowrap;
  }

  .video-record-control .ivu-switch {
    width: 96px;
    min-width: 96px;
    height: 24px;
    line-height: 22px;
    background: linear-gradient(135deg, #24506a, #326879) !important;
    border-color: #7ab9c1 !important;
  }

  .video-record-control .ivu-switch.ivu-switch-checked {
    background: linear-gradient(135deg, #16b89a, #138b9c) !important;
    border-color: #7cf2d2 !important;
    box-shadow: 0 0 10px rgba(22, 184, 154, 0.42);
  }

  .video-record-control .ivu-switch .ivu-switch-inner {
    color: #ffffff !important;
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
  }

  .video-record-control .ivu-switch.ivu-switch-checked .ivu-switch-inner {
    left: 8px;
  }

  .video-record-control .ivu-switch:not(.ivu-switch-checked) .ivu-switch-inner {
    left: 30px;
  }

  .video-record-control .ivu-switch:after {
    width: 20px;
    height: 20px;
    top: 1px;
  }

  .video-record-control .ivu-switch.ivu-switch-checked:after {
    left: 73px;
  }

  .video-record-control .ivu-switch:not(.ivu-switch-checked):after {
    left: 1px;
  }

  @media (max-width: 768px) {
    .history-video-heading {
      flex-wrap: wrap;
    }

    .history-video-heading .ivu-divider {
      flex-basis: 100%;
    }

    .video-record-control {
      margin: 0 0 6px;
    }
  }
}
</style>